import * as React from 'react'

export const IconBasket = () => (
  <svg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.707 4.121a1 1 0 0 0-1.414 0L8.414 7h7.172l-2.879-2.879ZM9.88 2.707a3 3 0 0 1 4.242 0L20.414 9H3.586l6.293-6.293Z'
      fill='#EEE6EF'
    />
    <path
      d='M2.163 8.141A1 1 0 0 1 3.153 7h17.694a1 1 0 0 1 .99 1.141l-1.469 10.283A3 3 0 0 1 17.398 21H6.602a3 3 0 0 1-2.97-2.576L2.163 8.141Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 11a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1ZM12 11a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1ZM16 11a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Z'
      fill='#EEE6EF'
    />
  </svg>
)
